export default __webpack_public_path__ + "static/media/teachers-and-kids-energy_audit.72650063.jpg";